import React from "react";
import { Check, ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Card, CardHeader, CardTitle, CardContent, CardFooter } from "@/components/ui/card";
const services = [{
  title: "Grabación Profesional",
  specs: ["Producción Musical con Tecnología Avanzada", "Composición de Canciones Personalizadas", "Desarrollo de Proyectos Musicales con Propósito", "Ambiente Creativo e Inspirador"]
}, {
  title: "Mezcla y Post-Producción",
  specs: ["Optimización Profesional del Audio", "Mejora de la Calidad del Sonido", "Claridad y Profundidad Sonora", "Edición y Ajuste de Voces"]
}, {
  title: "Masterización Final",
  specs: ["Optimización para Spotify, Apple Music y YouTube", "Sonido Balanceado y Consistente", "Calidad Profesional para Todos los Dispositivos", "Listo para Distribución Digital"]
}];
export default function ProducciNMusicalIntegral() {
  return <section data-section-id="241151" id="producción-musical-integral" className="bg-background text-foreground py-24 relative overflow-hidden">
      {}
      <div className="absolute inset-0 bg-[linear-gradient(to_right,var(--color-border)_1px,transparent_1px),linear-gradient(to_bottom,var(--color-border)_1px,transparent_1px)] bg-[size:4rem_4rem] opacity-5 [mask-image:radial-gradient(ellipse_80%_50%_at_50%_0%,#000_70%,transparent_100%)] pointer-events-none" />

      <div className="container mx-auto px-4 relative z-10 max-w-7xl">
        <div className="mb-16 max-w-2xl">
          <h2 className="text-3xl md:text-5xl font-default font-bold mb-4 tracking-tight text-foreground">Excelencia en Cada Nota.</h2>
          <p className="text-muted-foreground text-lg font-sans">
            Cada producción es desarrollada con dedicación y propósito, combinando creatividad y calidad para transmitir mensajes que inspiran y fortalecen la fe.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {services.map((service, i) => <div data-index={i} key={i} className="h-full">
              <Card className="group relative h-full flex flex-col border-border/40 bg-card/40 backdrop-blur-xl hover:border-primary/60 transition-all duration-500 hover:-translate-y-1 overflow-hidden rounded-lg border-l-4 border-l-transparent hover:border-l-secondary shadow-lg">
                {}
                <Link to="/ServicesPage" className="absolute inset-0 z-10">
                  <span className="sr-only">
                    Saber más sobre {service.title}
                  </span>
                </Link>

                <CardHeader className="border-b border-border/20 pb-5 mb-6">
                  <div className="text-[11px] font-mono text-secondary uppercase tracking-widest mb-3 flex items-center gap-2">
                    <span className="w-2 h-2 bg-secondary rounded-md inline-block animate-pulse" />
                    Especificaciones Técnicas
                  </div>
                  <CardTitle className="text-2xl font-default font-bold text-foreground tracking-tight">
                    {service.title}
                  </CardTitle>
                </CardHeader>

                <CardContent className="flex-grow">
                  <ul className="space-y-4">
                    {service.specs.map((spec, j) => <li key={j} data-index={j} className="flex items-start gap-3">
                        <Check className="size-5 text-primary shrink-0 mt-0.5 stroke-[3]" />
                        <span className="text-sm text-muted-foreground font-medium font-sans">
                          {spec}
                        </span>
                      </li>)}
                  </ul>
                </CardContent>

                <CardFooter className="pt-6 mt-auto justify-end border-t border-border/10">
                  <div className="flex items-center gap-2 text-secondary opacity-0 -translate-x-4 group-hover:opacity-100 group-hover:translate-x-0 transition-all duration-300 ease-out">
                    <span className="text-xs font-mono uppercase tracking-wider font-semibold">
                      Ver Detalles
                    </span>
                    <ArrowRight className="size-5" />
                  </div>
                </CardFooter>
                
                {}
                <div className="absolute top-0 right-0 w-16 h-16 bg-gradient-to-bl from-secondary/10 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500 pointer-events-none" />
              </Card>
            </div>)}
        </div>
      </div>
    </section>;
}